import type { IconData } from '@stacksjs/iconify-core'

export const triangle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21 20.794H3a1 1 0 0 1-.866-1.5l9-15.588a1.04 1.04 0 0 1 1.732 0l9 15.588a1 1 0 0 1-.866 1.5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default triangle
